<mat-accordion>
  <mat-expansion-panel
    [expanded]="true"
    #solarYieldExpansionPanel
    (click)="click(solarYieldExpansionPanel, $event)"
    class="solar-expansion-container"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div
          fxLayout="row wrap"
          fxFlex="100%;"
          fxFlex.xs="70%"
          fxLayout.xs="column"
        >
          <div
            fxFlex="33.3%;"
            fxFlex.xs="70%"
            fxLayout="row"
            fxLayoutAlign="left center"
            fxLayout.xs="column"
          >
            <ng-container *ngIf="icon">
              <i
                class="fa fa-sort-asc arrow-expansion-panel-customize asc"
                aria-hidden="true"
              ></i>
            </ng-container>
            <ng-container *ngIf="!icon">
              <i
                class="fa fa-sort-desc arrow-expansion-panel-customize desc"
                aria-hidden="true"
              ></i>
            </ng-container>
            <span class="title-header">Solar Yield Monitor</span>
          </div>
          <div fxFlex="33.3%;" fxFlex.xs="70%" fxLayout.xs="column">
            <mat-form-field>
              <mat-select
                id="select-yieldtype"
                ngDefaultControl
                [(ngModel)]="yieldTypeSelected"
                (ngModelChange)="onYieldTypeChange()"
              >
                <mat-option
                  *ngFor="let type of yieldTypes"
                  [value]="type.value"
                >
                  {{ type.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            fxFlex="33.3%;"
            fxFlex.xs="70%"
            fxLayout="row wrap"
            fxLayout.xs="column"
            fxLayoutAlign="center center"
          >
            <mat-checkbox
              ngDefaultControl
              [(ngModel)]="enableShiftwise"
              (change)="checkShiftwise($event)"
            ></mat-checkbox>
            &nbsp;
            <span class="show-building-label">Show Building wise output</span>
          </div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      id="chartContainer"
      class="yield-chart"
      style="max-width: 100%; width: 100%; margin: 0 auto"
    >
      <div
        [chart]="solarYieldChart"
        class="yield-chart"
        style="max-width: 100%; width: 100%; margin: 0 auto"
      ></div>
    </div>
    <mat-action-row class="expansion-footer">
      <mat-icon
        aria-hidden="false"
        aria-label="icon"
        class="Bosch-Ic-chart-OEE"
        style="width: max-content"
      ></mat-icon>
      <a [routerLink]="['/solar-long-term-trend']" [queryParams]="querySiteId"
        >Click for Long Term Trends</a
      >
    </mat-action-row>
  </mat-expansion-panel>
</mat-accordion>
